import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as AccountIconSvg } from '../../../assets/icons/building.svg';

export default function AccountIcon() {
  return <SvgIcon component={AccountIconSvg} sx={{ '& path': { fill: 'white' } }} />;
}
